module.exports = __webpack_public_path__ + "static/media/googleLogo.cbf40bae.svg";